import React, {useState, useEffect} from 'react';

export default function Invoices(){
    return(
        <div>
            <h1>Invoices</h1>
        </div>
    )
}